/**
 * i18n bootstrap — react-i18next, English only (ADR-058).
 *
 * Founder mandate (2026-05-14): the entire UI chrome is in English. User-
 * entered content (card titles, descriptions, chat messages) may be in any
 * language, but every menu, button, label, error and tooltip is English.
 *
 * react-i18next is kept (rather than ripped out) so the keyed-string pattern
 * stays — that decouples copy from components and enables Phase N+ to add a
 * second locale by dropping in another JSON bundle without touching any
 * component. No language detection, no locale storage.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enBundle from '../locales/en.json';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enBundle },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
